import { catchError, iif, map, Observable, of, switchMap } from 'rxjs';
import { UrlTree } from '@angular/router';
import { inject, Injectable } from '@angular/core';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root',
})
export class StandaloneAuthGuardService {
  #authService = inject(AuthService);

  signedInCheck(): Observable<boolean | UrlTree> {
    return this.#authService.isAuthorized$.pipe(
        switchMap(isAuthorized => iif(
            () => isAuthorized,
            of(true),
            this.#authService.refresh().pipe(
                map((): true => true),
                catchError(() => of(this.#authService.getSignInUrlTree())),
            ),
        )),
    );
  }

  signedOutCheck(): Observable<boolean | UrlTree> {
    return this.#authService.isAuthorized$.pipe(
        switchMap(isAuthorized => iif(
            () => isAuthorized,
            of(this.#authService.getPostSignInUrlTree()),
            this.#authService.refresh().pipe(
                map(() => this.#authService.getPostSignInUrlTree()),
                catchError(() => of(true)),
            ),
        )),
    );
  }
}
